<template>
  <iframe :src="webUrl+'/admin/stock/list'"></iframe>
</template>

<script>
export default {
  name: "stock",
  emits : [ 'setMenuKey' ],
  setup(props,{emit}){
    emit('setMenuKey', 'kc.yhsckc')
    return {
      "webUrl" : process.env.VUE_APP_DAILIAO_WEB_URL
    }
  }
}
</script>

<style scoped>

</style>